import { WindTurbineBlades } from "./WindTurbineBlades";
export default WindTurbineBlades;
